import React, {Fragment, useEffect, useState} from 'react';
import {Section, Explanation_text, Info, Popup, Select, Text, Chip_input, Accordion, Form} from '../../../../components';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import CustomFieldIcon from '@material-ui/icons/List';
import StageIcon from '@material-ui/icons/FilterNone';
import WebIcon from '@material-ui/icons/Web';
import WorkIcon from '@material-ui/icons/Work';
import DeleteIcon from '@material-ui/icons/Delete';
import SalesCoachForm from '../Form/SalesCoachForm';
import Custom_fields from '../../Setup/Custom_fields';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {connect} from 'react-redux';
import axios from 'axios';

function SalesCoachSetup(props){
  const[field_form, setFieldForm]=useState(false);
  const[contact_field_form, setContactFieldForm]=useState(false);
  const[user_field_form, setUserFieldForm]=useState(false);
  const[sales_coach_form, setSalesCoachForm]=useState(undefined);
  const[delete_popup, setDelete]=useState(undefined);
  const[delete_pipeline_popup, setDeletePipeline]=useState(undefined);
  const[document_preview_popup, setDocumentPreviewPopup]=useState(undefined);
  const[deal_setup_popup, setDealSetupPopup]=useState(false);
  //INCLIDE DEFAULTS IS ACTUALLY INCLUDE INACTIVE
  const[include_defaults, setIncludeDefaults]=useState(false);
  const[update_default_popup, setUpdateDefaultPopup]=useState(undefined);
  //let custom_deal_fields=[];
  //let custom_contact_fields=[];
  //let custom_user_fields=[];

  useEffect(()=>{
    if(props.deal_pipelines==undefined){ console.log('INDEXX'); props.indexDealPipelines();}
    if(props.custom_deal_fields==undefined){props.indexCustomDealFields();}
    if(props.quizzes_index!=true){props.indexQuizzes();}
    if(props.documents_index!=true){props.indexDocuments();}
    if(props.checklists_index!=true){props.indexChecklists();}

  },[])

//  if(props.custom_deal_fields!=undefined){
//    for(let key in props.custom_deal_fields){
//      if(props.custom_deal_fields[key].deleted_at!=null){custom_deal_fields.push(props.custom_deal_fields[key]);}else{custom_deal_fields.unshift(props.custom_deal_fields[key]);}
//    }
//  }
//
//  if(props.custom_contact_fields!=undefined){
//    for(let key in props.custom_contact_fields){
//      if(props.custom_contact_fields[key].deleted_at!=null){custom_contact_fields.push(props.custom_contact_fields[key]);}else{custom_contact_fields.unshift(props.custom_contact_fields[key]);}
//    }
//  }
//
//  if(props.custom_user_fields!=undefined){
//    for(let key in props.custom_user_fields){
//      if(props.custom_user_fields[key].deleted_at!=null){custom_user_fields.push(props.custom_user_fields[key]);}else{custom_user_fields.unshift(props.custom_user_fields[key]);}
//    }
//  }


  let deal_pipelines=[]; let has_defaults=false;
  if(props.deal_pipelines!=undefined){
    for(let dp of props.deal_pipelines){
      if(dp.active!=true){has_defaults=true; if(include_defaults==true){deal_pipelines.unshift(dp);}}else{deal_pipelines.push(dp);}
    }
  }

  function getDealPipeline(deal_pipelines, dpid){for(let dp of deal_pipelines){if(dp.id==dpid){return dp.name}}}

  return(
    <Fragment>
    <div style={{height:'30px'}}/>
    {(props.workspace!=undefined)?<Section icon={<WorkIcon color='primary'/>} title={<Fragment><Explanation_text inline text='deal_setup_title'/><Info name='deal_setup'/></Fragment>} maxWidth='600px' action={<Tooltip title='Edit'><EditIcon color='primary' onClick={()=>{setDealSetupPopup(true);}} style={{fontSize:'20px', cursor:'pointer'}}/></Tooltip>}>
          <Input_option title='Deal display first' value={(props.workspace.deal_first==true)?'ON':'OFF'}/>
          <Input_option title='Deal filter on timeline' value={(props.workspace.deal_filter_restrictive==true)?'Show deal-specific items only':'Show deal-specific items + items without a deal'}/>
          <div style={{marginTop:'20px'}}/>
          <Input_option title='Deal auto create status' value={(props.workspace.deal_auto_create_status==null || props.workspace.deal_auto_create_status==0)?'OFF':props.workspace.deal_auto_create_status}/>
          <Input_option title='Default deal pipeline' value={(props.workspace.deal_auto_pipeline_id==null  || props.deal_pipelines==undefined)?'None':getDealPipeline(props.deal_pipelines, props.workspace.deal_auto_pipeline_id)}/>
          <Input_option title='Default deal name' value={props.workspace.deal_auto_create_name}/>
        </Section>:null}
    {(deal_setup_popup!=true)?null:<Deal_setup_popup {...props} deal_pipelines={deal_pipelines} handleClose={()=>{setDealSetupPopup(false);}}/>}

    <Section  no_padding icon={<StageIcon style={{marginLeft:'10px'}}/>} title={<Fragment><Explanation_text inline text='sales_coach_setup_title'/><Info name='sales_coach_setup'/></Fragment>} maxWidth='600px' action={<Tooltip title='Edit sales coach'><Button variant='contained' color='primary' onClick={()=>{setSalesCoachForm('new');}} >New</Button></Tooltip>}>
      {(has_defaults==true)?<div style={{marginLeft:'20px', marginTop:'-10px'}}><FormControlLabel control={<Switch checked={include_defaults} onChange={()=>{setIncludeDefaults(!include_defaults);}} />} label="Show inactive" /></div>:null}
      {deal_pipelines.map(function(dp){
        return(
          <Grid item xs={12}>
          <Accordion content={[{title:<Typography style={{position:'relative', width:'calc(100% - 40px)'}} color={(dp.deleted_at==null)?undefined:'error'}>{dp.name}{(dp.pushed_by_defaults==true && dp.block_default_push!=true)?<Typography variant='caption' style={{position:'absolute', right:'-10px', top:'2px', fontSize:'10px', fontWeight:'bold'}}>DEFAULT</Typography>:null}<EditIcon style={{position:'absolute', right:'-30px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='primary' onClick={()=>{if(dp.block_default_push!=true && dp.pushed_by_defaults==true){setUpdateDefaultPopup(dp);}else{setSalesCoachForm(dp);}}}/><DeleteIcon style={{position:'absolute', right:'-50px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='error' onClick={()=>{setDeletePipeline(dp);}}/></Typography>,
            content:<Grid container style={{marginTop:'-20px', marginLeft:'-5px'}}>
            <Grid item xs={12} style={{marginBottom:'10px'}}><Typography variant='caption'><div style={{width:'calc(100% - 40px)'}}>{dp.description}</div></Typography></Grid>
            <Grid item xs={4}><Typography color='primary'>Stage</Typography></Grid>
            <Grid item xs={4}><Typography color='primary'>Document</Typography></Grid>
            <Grid item xs={2}><Typography color='primary'>Checklist</Typography></Grid>
            <Grid item xs={2}><Typography color='primary'>Quiz</Typography></Grid>
            <Grid item xs={12} style={{marginTop:'10px'}}>
                {dp.deal_stages.map(function(u){
                  console.log(u, u.weight, Math.round(u.weight/100))
                  return(
                    <Grid container style={{marginTop:'3px', marginBottom:'3px'}}>
                      <Grid item xs={4}><Typography variant='caption' color='primary'>{u.name+' ('+Math.round(u.weight/100)+'%)'}</Typography></Grid>
                      <Grid item xs={4}><Tooltip label={(u.documents[0]!=undefined && u.documents[0].id!=undefined && props.documents!=undefined && props.documents[u.documents[0].id]!=undefined)?props.documents[u.documents[0].id].notes:null}><Typography variant='caption' onClick={()=>{setDocumentPreviewPopup((u.documents[0]!=undefined && u.documents[0].id!=undefined && props.documents!=undefined && props.documents[u.documents[0].id]!=undefined)?props.documents[u.documents[0].id]:null);}}>{(u.documents[0]!=undefined && u.documents[0].id!=undefined && props.documents!=undefined && props.documents[u.documents[0].id]!=undefined)?props.documents[u.documents[0].id].name:null}</Typography></Tooltip></Grid>
                      <Grid item xs={2}><Tooltip label={(u.checklist_id!=undefined && props.checklists!=undefined && props.checklists[u.checklist_id]!=undefined)?props.checklists[u.checklist_id].description:null}><Typography variant='caption'>{(u.checklist_id!=undefined && props.checklists!=undefined && props.checklists[u.checklist_id]!=undefined)?props.checklists[u.checklist_id].name:null}</Typography></Tooltip></Grid>
                      <Grid item xs={2}><Tooltip label={(u.quizz_id!=undefined && props.quizzes!=undefined && props.quizzes[u.quizz_id]!=undefined)?props.quizzes[u.quizz_id].description:null}><Typography variant='caption'>{(u.quizz_id!=undefined && props.quizzes!=undefined && props.quizzes[u.quizz_id]!=undefined)?props.quizzes[u.quizz_id].name:null}</Typography></Tooltip></Grid>
                    </Grid>
                  )})
                }
            </Grid>
            </Grid>
          }]}/>
          </Grid>
        )
      })}
      {(sales_coach_form!=undefined)?<SalesCoachForm {...props} deal_pipeline={(sales_coach_form=='new')?undefined:sales_coach_form} handleClose={()=>{setSalesCoachForm(undefined)}}/>:null}
      {(delete_popup!=undefined)?<DeleteDealCustomField {...props} custom_deal_field={delete_popup} handleClose={()=>{setDelete(undefined)}}/>:null}
      {(delete_pipeline_popup!=undefined)?<DeleteDealPipeline {...props} deal_pipeline={delete_pipeline_popup} handleClose={()=>{setDeletePipeline(undefined)}}/>:null}

  </Section>
  <Custom_fields {...props} types={["DEAL","CONTACT"]}/>
    <div style={{height:'50px'}}/>
    </Fragment>
  )
}




function Deal_setup_popup(props){

  function onSubmit(params){
    axios.post('/api/autoDealSetup', params).then(()=>{
      window.location.href='/sales_coach/setup';
    })
  }

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={(props.workspace==undefined)?{}:{deal_filter_restrictive:props.workspace.deal_filter_restrictive, deal_auto_create_name:props.workspace.deal_auto_create_name, deal_auto_create_status:(props.workspace.deal_auto_create_status==undefined || props.workspace.deal_auto_create_status=='')?'turn_off':props.workspace.deal_auto_create_status, deal_auto_pipeline_id:props.workspace.deal_auto_pipeline_id, deal_first:props.workspace.deal_first}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup always_open title={'Deal setup'} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} handleClose={props.handleClose} content={
          <div style={{width:'95vw', maxWidth:'600px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Grid container style={{width:'calc(100% - 40px)', marginLeft:'10px', marginTop:'0px', marginBottom:'20px'}}>
            <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'0px'}}><Field name='deal_first'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Deal display first"/>}/>}</Field></div>
            <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'0px', marginBottom:'0px'}}><Field name='deal_filter_restrictive'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Filter includes only timeline activity with a deal"/>}/>}</Field></div>
            <Typography variant='caption' style={{marginTop:'20px', width:'calc(100% - 40px)', marginLeft:'22px'}}>Set defaults for your deals to auto-populate new ones. Enable auto-create on status for automatic deal creation.</Typography>
            <Grid item xs={8} style={{marginTop:'15px', marginLeft:'10px'}}><Select title='Automatically create deal at status' variant='outlined' name='deal_auto_create_status' enum='status' unshift_select_data={[{value:'turn_off', name:'Turn Off'}]}/></Grid>
            <Grid item xs={8} style={{marginTop:'15px', marginLeft:'10px'}}><Select title='Default deal pipeline' variant='outlined' name='deal_auto_pipeline_id' select_data={props.deal_pipelines}/></Grid>
            <Grid item xs={8} style={{marginTop:'15px', marginLeft:'10px'}}><div style={{width:'100%', marginTop:'0px'}}><Text required variant='outlined' title='Default deal name' name='deal_auto_create_name'/></div></Grid>
          </Grid>
          </div>
        }/>
        </form>
      )}
      </Form>
  )
}



function DeleteDealPipeline(props){


  function onDelete(id){
    props.deleteDealPipeline(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={(props.deal_pipeline.pushed_by_defaults==true && props.deal_pipeline.block_default_push!=true)?'Warning':'Delete deal pipeline'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.deal_pipeline.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{(props.deal_pipeline.pushed_by_defaults==true && props.deal_pipeline.block_default_push!=true)?<Explanation_text text='delete_deal_pipeline_default_text'/>:"Are you sure you want to permanently delete '"+props.deal_pipeline.name+"' pipeline? This action can not be undone, and may affect various deals as well as functionality within sales coach."}</Typography></div>
      </div>
    }/>
  )
}


function Update_default_popup(props){

  return(
    <Popup always_open title={'Warning'} accept_button='Edit' handleClose={props.handleClose} accept_button_click={()=>{props.accept(props.default);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}><Explanation_text text='update_default_popup_text'/></Typography></div>
      </div>
    }/>
  )
}


//<Fragment>
//  <Section  icon={<CustomFieldIcon style={{marginLeft:'10px'}}/>} no_padding title={<Fragment><Explanation_text inline text='custom_user_field_setup_title'/><Info name='custom_user_field_setup'/></Fragment>} maxWidth='600px' action={<Tooltip title='New custom user field'><Button variant='contained' color='primary' onClick={()=>{setUserFieldForm(true);}} >New</Button></Tooltip>}>
//    <Grid container style={{marginTop:'30px', marginLeft:'-5px', width:'calc(100% + 5px)'}}>
//    {custom_user_fields.map(function(cdf){
//      return(
//        <Grid item xs={12}>
//        <Accordion  content={[{title:<Typography style={{position:'relative', width:'calc(100% - 40px)'}} color={(cdf.deleted_at==null)?undefined:'error'}>{cdf.name}<EditIcon style={{position:'absolute', right:'-30px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='primary' onClick={()=>{setUserFieldForm(cdf);}}/><DeleteIcon style={{position:'absolute', right:'-50px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='error' onClick={()=>{setDelete(cdf);}}/></Typography>,
//          content:<Grid container style={{marginTop:'-20px'}}>
//          <Grid item xs={12} style={{marginBottom:'10px'}}><Typography variant='caption'><div style={{width:'calc(100% - 40px)'}}>{cdf.description}</div></Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Option</Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Document</Typography></Grid>
//          <Grid item xs={2}/>
//          <Grid item xs={2}><Typography color='primary'>Deleted</Typography></Grid>
//          <Grid item xs={12} style={{marginTop:'10px'}}>
//              {cdf.custom_deal_field_options.map(function(u){
//                return(
//                  <Grid container style={{marginTop:'3px', marginBottom:'3px'}}>
//                    <Grid item xs={4}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{u.name}</Typography></Grid>
//                    <Grid item xs={4}><Tooltip label={(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].notes:null}><Typography variant='caption' color={(u.deleted_at==null)?undefined:'error'}>{(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].name:null}</Typography></Tooltip></Grid>
//                    <Grid item xs={2}>{(u.document_id==null)?null:<WebIcon style={{cursor:'pointer'}} color={(u.deleted_at==null)?undefined:'error'} onClick={()=>{setDocumentPreviewPopup((u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id]:null);}}/>}</Grid>
//                    <Grid item xs={2}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{(u.deleted_at==undefined)?undefined:u.deleted_at.split('T')[0]}</Typography></Grid>
//                  </Grid>
//                )})
//              }
//          </Grid>
//          </Grid>
//        }]}/>
//        </Grid>
//      )
//    })}
//    </Grid>
//    {(document_preview_popup!=undefined)?<Document_preview_popup {...props} document={document_preview_popup} handleClose={()=>{setDocumentPreviewPopup(undefined)}}/>:null}
//    {(user_field_form!==false)?<SalesCoachFieldForm {...props} type='users' custom_deal_field={(user_field_form===true)?undefined:user_field_form} handleClose={()=>{setUserFieldForm(false)}}/>:null}
//  </Section>
//  <Section  icon={<CustomFieldIcon style={{marginLeft:'10px'}}/>} no_padding title={<Fragment><Explanation_text inline text='custom_contact_field_setup_title'/><Info name='custom_contact_field_setup'/></Fragment>} maxWidth='600px' action={<Tooltip title='New custom contact field'><Button variant='contained' color='primary' onClick={()=>{setContactFieldForm(true);}} >New</Button></Tooltip>}>
//    <Grid container style={{marginTop:'30px', marginLeft:'-5px', width:'calc(100% + 5px)'}}>
//    {custom_contact_fields.map(function(cdf){
//      return(
//        <Grid item xs={12}>
//        <Accordion  content={[{title:<Typography style={{position:'relative', width:'calc(100% - 40px)'}} color={(cdf.deleted_at==null)?undefined:'error'}>{cdf.name}<EditIcon style={{position:'absolute', right:'-30px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='primary' onClick={()=>{setContactFieldForm(cdf);}}/><DeleteIcon style={{position:'absolute', right:'-50px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='error' onClick={()=>{setDelete(cdf);}}/></Typography>,
//          content:<Grid container style={{marginTop:'-20px'}}>
//          <Grid item xs={12} style={{marginBottom:'10px'}}><Typography variant='caption'><div style={{width:'calc(100% - 40px)'}}>{cdf.description}</div></Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Option</Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Document</Typography></Grid>
//          <Grid item xs={2}/>
//          <Grid item xs={2}><Typography color='primary'>Deleted</Typography></Grid>
//          <Grid item xs={12} style={{marginTop:'10px'}}>
//              {cdf.custom_deal_field_options.map(function(u){
//                return(
//                  <Grid container style={{marginTop:'3px', marginBottom:'3px'}}>
//                    <Grid item xs={4}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{u.name}</Typography></Grid>
//                    <Grid item xs={4}><Tooltip label={(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].notes:null}><Typography variant='caption' color={(u.deleted_at==null)?undefined:'error'}>{(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].name:null}</Typography></Tooltip></Grid>
//                    <Grid item xs={2}>{(u.document_id==null)?null:<WebIcon style={{cursor:'pointer'}} color={(u.deleted_at==null)?undefined:'error'} onClick={()=>{setDocumentPreviewPopup((u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id]:null);}}/>}</Grid>
//                    <Grid item xs={2}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{(u.deleted_at==undefined)?undefined:u.deleted_at.split('T')[0]}</Typography></Grid>
//                  </Grid>
//                )})
//              }
//          </Grid>
//          </Grid>
//        }]}/>
//        </Grid>
//      )
//    })}
//    </Grid>
//    {(document_preview_popup!=undefined)?<Document_preview_popup {...props} document={document_preview_popup} handleClose={()=>{setDocumentPreviewPopup(undefined)}}/>:null}
//    {(contact_field_form!==false)?<SalesCoachFieldForm {...props} type='contacts' custom_deal_field={(contact_field_form===true)?undefined:contact_field_form} handleClose={()=>{setContactFieldForm(false)}}/>:null}
//  </Section>
//  <Section  icon={<CustomFieldIcon style={{marginLeft:'10px'}}/>} no_padding title={<Fragment><Explanation_text inline text='custom_deal_field_setup_title'/><Info name='custom_deal_field_setup'/></Fragment>} maxWidth='600px' action={<Tooltip title='New custom deal field'><Button variant='contained' color='primary' onClick={()=>{setFieldForm(true);}} >New</Button></Tooltip>}>
//    <Grid container style={{marginTop:'30px', marginLeft:'-5px', width:'calc(100% + 5px)'}}>
//    {custom_deal_fields.map(function(cdf){
//      return(
//        <Grid item xs={12}>
//        <Accordion  content={[{title:<Typography style={{position:'relative', width:'calc(100% - 40px)'}} color={(cdf.deleted_at==null)?undefined:'error'}>{cdf.name}<EditIcon style={{position:'absolute', right:'-30px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='primary' onClick={()=>{setFieldForm(cdf);}}/><DeleteIcon style={{position:'absolute', right:'-50px', top:'2px', fontSize:'18px', cursor:'pointer'}} color='error' onClick={()=>{setDelete(cdf);}}/></Typography>,
//          content:<Grid container style={{marginTop:'-20px'}}>
//          <Grid item xs={12} style={{marginBottom:'10px'}}><Typography variant='caption'><div style={{width:'calc(100% - 40px)'}}>{cdf.description}</div></Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Option</Typography></Grid>
//          <Grid item xs={4}><Typography color='primary'>Document</Typography></Grid>
//          <Grid item xs={2}/>
//          <Grid item xs={2}><Typography color='primary'>Deleted</Typography></Grid>
//          <Grid item xs={12} style={{marginTop:'10px'}}>
//              {cdf.custom_deal_field_options.map(function(u){
//                return(
//                  <Grid container style={{marginTop:'3px', marginBottom:'3px'}}>
//                    <Grid item xs={4}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{u.name}</Typography></Grid>
//                    <Grid item xs={4}><Tooltip label={(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].notes:null}><Typography variant='caption' color={(u.deleted_at==null)?undefined:'error'}>{(u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id].name:null}</Typography></Tooltip></Grid>
//                    <Grid item xs={2}>{(u.document_id==null)?null:<WebIcon style={{cursor:'pointer'}} color={(u.deleted_at==null)?undefined:'error'} onClick={()=>{setDocumentPreviewPopup((u.document_id!=undefined && props.documents!=undefined && props.documents[u.document_id]!=undefined)?props.documents[u.document_id]:null);}}/>}</Grid>
//                    <Grid item xs={2}><Typography variant='caption' color={(u.deleted_at==null)?'primary':'error'}>{(u.deleted_at==undefined)?undefined:u.deleted_at.split('T')[0]}</Typography></Grid>
//                  </Grid>
//                )})
//              }
//          </Grid>
//          </Grid>
//        }]}/>
//        </Grid>
//      )
//    })}
//    </Grid>
//    {(update_default_popup!=undefined)?<Update_default_popup {...props} default={update_default_popup} handleClose={()=>{setUpdateDefaultPopup(undefined)}} accept={(x)=>{setSalesCoachForm(x);}}/>:null}
//    {(document_preview_popup!=undefined)?<Document_preview_popup {...props} document={document_preview_popup} handleClose={()=>{setDocumentPreviewPopup(undefined)}}/>:null}
//    {(field_form!==false)?<SalesCoachFieldForm {...props} custom_deal_field={(field_form===true)?undefined:field_form} handleClose={()=>{setFieldForm(false)}}/>:null}
//  </Section>
//  </Fragment>}

//
//function Document_preview_popup(props){
//
//  return(
//    <Popup  always_open
//            height={'95vh'}
//            width={'100vw'}
//            maxWidth={'800px'}
//            title={props.document.name}
//            icon={<WebIcon color='primary'/>}
//            content={
//              <Fragment>
//              <div style={{width:'100vw', height:'80vh', maxWidth:'800px', position:'relative', overflow:'hidden'}}>
//                  {<iframe style={{width:'100%', height:'100%'}} src={'/document/'+props.document.path}/>}
//              </div>
//              </Fragment>
//            }
//            handleClose={props.handleClose}
//    />
//  )
//}

//

//function DeleteDealCustomField(props){

//
//  function onDelete(id){
//    props.deleteCustomDealField(id);
//    props.handleClose();
//  }
//
//  return(
//    <Popup always_open title={'Delete custom deal field'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.custom_deal_field.id);}} content={
//      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
//        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to permanently delete '"+props.custom_deal_field.name+"' custom deal field? This action can not be undone, and may affect various deals as well as functionality within sales coach, such as conditional checklist steps, or displaying certain documents."}</Typography></div>
//      </div>
//    }/>
//  )
//}


//function SalesCoachFieldForm(props){
//  const[error, setError]=useState({});
//  function onSubmit(params){
//    params.type=(props.type=='contacts')?1:(props.type=='users')?2:0;
//    if(props.custom_deal_field!=undefined){props.updateCustomDealField(props.custom_deal_field.id, params);}
//    else{props.createCustomDealField(params);}
//  }

//
//
//  let init=(props.custom_deal_field==undefined)?{}:props.custom_deal_field;
//  let documents_select=[{id:'', name:'None'}];
//  if(props.documents!=undefined){for(let key in props.documents){documents_select.push(props.documents[key]);}}
//
//  return(
//    <Form
//      onSubmit={onSubmit}
//      initialValues={init}
//      mutators={{
//        ...arrayMutators
//      }}
//      handleClose={props.handleClose}
//      >
//      {form_props => (
//    <form autocomplete='off' onSubmit={form_props.handleSubmit}>
  //  <Popup always_open handleClose={props.handleClose} title={(props.type=='contacts')?(props.custom_deal_field!=undefined)?'custom_contact_field_update_popup_title':'custom_contact_field_create_popup_title':(props.type=='users')?(props.custom_deal_field!=undefined)?'custom_user_field_update_popup_title':'custom_user_field_create_popup_title':(props.custom_deal_field!=undefined)?'custom_deal_field_update_popup_title':'custom_deal_field_create_popup_title'} //accept_button_click={()=>{form_props.form.submit();}} content={
//      <div>
//      <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)'}}>
//      <Grid item xs={6}><Text title='Name' name='name'/></Grid>
//      <Grid item xs={12}><FieldArray name='custom_deal_field_options'>
//      {({ fields }) =>
//        <Fragment>
//        <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px', position:'relative', width:'calc(100% - 20px)'}}><span><CustomFieldIcon color='primary' style={{position:'absolute', left:'0px'}}/></span><span style={{marginLeft:'40px'}}>Options</span><AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push({}, undefined)}}/></Typography>
//        {fields.map((name, index) => {
//          return(
//            <Fragment>
//            <hr style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}/>
//            <Grid container>
  //                <Grid item xs={5}><Text size='small' title='Name' name={`${name}.name`}/></Grid><Grid item xs={5}><Select size='small' title='Document' style={{marginTop:'5px'}} name={`${name}.document_id`} select_data={documents_select}/></Grid><Grid item xs={2}><Field name={`${name}.restore`}>{(ff)=><Field name={`${name}.deleted_at`}>{(f)=>(f.input.value!=undefined && f.input.value!=null && f.input.value!='')?<Button onClick={()=>{ff.input.onChange(true); f.input.onChange(undefined);}} //style={{marginTop:'10px'}} variant='contained' color='secondary'>Restore</Button>:<DeleteIcon color='secondary' style={{marginTop:'5px'}} onClick={()=>{fields.remove(index);}}/>}</Field>}</Field></Grid>
//
//            </Grid>
//            </Fragment>
//        )})}
//        </Fragment>
//      }</FieldArray></Grid>
//      <Grid item xs={12} style={{marginTop:'20px'}}><Text title='Description' name='description' multiline rows={3}/></Grid>
//      </Grid>
//      </div>
//    }  accept_button={(props.custom_deal_field!=undefined)?'Save':'Create'}/>
//      </form>
//    )}</Form>
//  );
//}

function Input_option(props){return(<Typography variant='caption'><Grid container><Grid item xs={6} sm={4}><Explanation_text style='bold_caption' text={props.title}/>:</Grid><Grid item xs={6} sm={8}>{(Array.isArray(props.value)==false)?props.value:props.value.map(function(v){return(<span style={{margin:'1px', marginBottom:'1px'}}><Chip style={{fontSize:'10px', paddingLeft:'0.5px', marginRight:'0.5px', height:'15px'}} size="small" label={v}/></span>)})}</Grid></Grid></Typography>)}




export default connect(ss, dd)(SalesCoachSetup);


function ss(state){
  return{
    deal_pipelines:state.deals.pipelines,
    custom_deal_fields:state.deals.custom_fields,
    custom_contact_fields:state.deals.custom_contact_fields,
    custom_user_fields:state.deals.custom_user_fields,
    quizzes:state.sales_coach.quizzes,
    refresh:state.sales_coach.refresh,
    refresh_deals:state.deals.refresh,
    quizzes_index:state.sales_coach.quizzes_index,
    documents:state.sales_coach.documents,
    documents_index:state.sales_coach.documents_index,
    checklists:state.sales_coach.checklists,
    checklists_index:state.sales_coach.checklists_index,
    refresh_workspace:state.workspaces.refresh,
  }
}


function dd(dispatch){
  return{
    indexDealPipelines:()=>{dispatch({type:'REQUEST_INDEX_DEAL_PIPELINES'});},
    indexDocuments:()=>{dispatch({type:'REQUEST_INDEX_DOCUMENTS'});},
    indexChecklists:()=>{dispatch({type:'REQUEST_INDEX_CHECKLISTS'});},
    indexQuizzes:()=>{dispatch({type:'REQUEST_INDEX_QUIZZES'});},
    indexCustomDealFields:()=>{dispatch({type:'REQUEST_INDEX_CUSTOM_DEAL_FIELDS'})},
    createCustomDealField:(data)=>{dispatch({type:'REQUEST_CREATE_CUSTOM_DEAL_FIELD', data:data})},
    updateCustomDealField:(id, data)=>{dispatch({type:'REQUEST_UPDATE_CUSTOM_DEAL_FIELD', id:id, data:data})},
    deleteCustomDealField:(id)=>{dispatch({type:'REQUEST_DELETE_CUSTOM_DEAL_FIELD', id:id})},
    deleteDealPipeline:(id)=>{dispatch({type:'REQUEST_DELETE_DEAL_PIPELINE', id:id})},
  }
}
